import { Paper } from '@mui/material';
import styled from 'styled-components';

export const StyledPaper = styled(Paper)`
  padding: 18px;
  margin-bottom: 12px;
`;
